import React from 'react';
import '../styles/ErrorMessage.css';

const ErrorMessage = props => <div {...props} className="ErrorMessage pa3 f6 lh-copy" />;

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/ErrorMessage.js